import ReactDOM from "react-dom";
import { useEffect, useRef } from "react";
import { Button } from "../generic/Core";
import Modal from "./Modal";

import useTranslation from "../../hooks/useTranslation";
import CoreForm from "../cardView/CoreForm";
import processDefaults from "../../utils/defaults/processDefaults";
import useProfile from "../../hooks/useProfile";
import { useSnapshot } from "valtio";

import { useModalStore } from "./PopUp";

export function PopUpModal({ zIndex, onClose, setShow, config, setAction, mode, data = {} }) {
    //Translation Use on the Modal with regulat t and m for Merge fields
    const { t, m } = useTranslation()
    const dismissBtnRef = useRef(null)
    const timeOutRef = useRef(null)
    const { pState } = useProfile()
    const profile = useSnapshot(pState)

    const show = true

    const [state, setState] = useModalStore((s) => s)

    if (config === undefined) {
        config = { header: 'undefined', body: [], footer: [] }
    }

    const localDispatch = () => {
    }

    //Function that handles the choice on the Modal.
    //'dismiss' is the only action that stops here - everything else is dispatched.
    const handleClick = (action, target, actionType) => {
        if (action !== 'dismiss') {
            const payload = { data: state, config: config }
            setAction({ action, target, actionType, payload })
        }
        onClose()
    }

    //Function that when it detect an enter changes the focus to the dismiss button and clicks on it.
    const handleKeyDown = (e) => {
        //Condition checks if Enter is pressed and if the target is the same as the dismiss Button
        if (e.key === 'Enter' & e.target === dismissBtnRef.current) {
            dismissBtnRef.current.click()
            //If a timeOutRef exists, it is cleared.
            if (timeOutRef.current !== null) {
                clearTimeout(timeOutRef.current);
            }
        }
    };

    //Function that once the visibility of the modal changes, sets the focus on the dismiss button with a delay of 50 mSec
    useEffect(() => {
        if (show) {
            timeOutRef.current = setTimeout(() => {
                if (dismissBtnRef.current) dismissBtnRef.current.focus();
            }, 50);
        }

        //If there is a form, it loads the defaults
        if (config.form) {
            const translatedConfig = config?.form?.section || {}
            const result = processDefaults([translatedConfig], profile, [], data, t)
            setState(result)
        }
    }
        , [show])

    return ReactDOM.createPortal(
            <Modal zIndex={zIndex} onClose={onClose} setShow={setShow} show={show} mode={mode} className={show && (mode === 'fullscreen') ? 'fullscreen' : 'animate'} handleKeyDown={handleKeyDown}>
                <Modal.Header onClose={onClose}>
                    <h4>{t(config.header)}</h4>
                </Modal.Header>
                <Modal.Body >
                    {config?.body &&config.body.map((text, i) => {
                        return (
                            //config.params carries the merge values for any ${n} in the body.
                            <p key={i}>{m(text, config.params)}</p>
                        )
                    })}
                    {config.form && <CoreForm
                        section={config.form.section}
                        dispatch={localDispatch}
                        validated=''
                        entity='modal'
                        useStore={useModalStore}
                    />
                    }
                </Modal.Body>
                <Modal.Footer>
                    {config?.footer && config.footer.map(
                        (item, i) => (
                            //The dismiss button takes the focus ref - exactly one per footer,
                            //so Enter can never land on a button that dispatches.
                            <Button key={i} ref={item.action === 'dismiss' ? dismissBtnRef : undefined}
                            $variant={item.type} onClick={() => { handleClick(item.action, item.target, item.actionType) }}
                            data-testid={`${config.id}.${item.action}`}
                            >{t(item.text)}</Button>
                        )
                    )}
                </Modal.Footer>
            </Modal>
    , document.body);
}
